<ion-item class="detail-list-item" [detail]="true" button (click)="openDetail.emit(item)">
  <div class="detail-list-item__value">{{previewText}}</div>
</ion-item>
